import { render, staticRenderFns } from "./AppFeaturesCarousel.vue?vue&type=template&id=c723cc38&scoped=true"
import script from "./AppFeaturesCarousel.vue?vue&type=script&lang=js"
export * from "./AppFeaturesCarousel.vue?vue&type=script&lang=js"
import style0 from "./AppFeaturesCarousel.vue?vue&type=style&index=0&id=c723cc38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c723cc38",
  null
  
)

export default component.exports